"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorReport = void 0;
const resource_model_1 = require("./resource.model");
const clientInfo_model_1 = require("./clientInfo.model");
/**
 * Table: `idea_projects_errorsReports`.
 */
class ErrorReport extends resource_model_1.Resource {
    load(x) {
        super.load(x);
        this.project = this.clean(x.project, String);
        this.version = this.clean(x.version, String);
        this.stage = this.clean(x.stage, String);
        this.createdAt = this.clean(x.createdAt, t => new Date(t).toISOString());
        this.expiresAt = this.clean(x.expiresAt, Number);
        this.type = this.clean(x.type, String);
        this.error = this.clean(x.error, String);
        this.stack = this.clean(x.stack, String);
        this.client = new clientInfo_model_1.ClientInfo(x.client);
    }
}
exports.ErrorReport = ErrorReport;
